module.exports = __webpack_public_path__ + "img/bbl.4c60e5d4.svg";